<template>
  <app-layout :account-global-menu="accountGlobalMenu" ref="appLayoutRef">
    <template  v-if="accountStore.studentProfile" #main-content>
      <main id="content" class="l-main p-account">
        <div class="l-main__inner">
          <div class="c-page-header">
            <h1 class="c-page-header-title">アカウント情報</h1>
            <button-return @click="goBack" name="S6-1-back-btn">戻る</button-return>
          </div>
          <Logout></Logout>
          <section>
            <div class="p-account-thumbnail">
              <div class="userThumb">
                <img src="@/styles/img/dummy/img_thumb_profile.jpg" :alt="accountStore.studentProfile.profile.name">
              </div>
            </div>
            <div class="c-parts-box -account">
              <div class="c-parts-box__inner">
                <table class="c-table">
                  <tbody>
                    <tr>
                      <th>名前</th>
                      <td>{{accountStore.studentProfile.profile.name}}</td>
                    </tr>
                    <tr>
                      <th>学校名</th>
                      <td>{{accountStore.studentProfile.profile.school.name}}</td>
                    </tr>
                    <tr>
                      <th>学級・出席番号</th>
                      <td v-if="nextGradeStore.classroom_list.length === 0">{{accountStore.studentProfile.profile.classroom.name}} {{accountStore.studentProfile.profile.number}}</td>
                      <td v-else>
                        <p class="c-parts-error">設定されていません</p>
                        <span  class="c-button-blue -small-2" @click="appLayoutRef.openNextGradeModal1()">
                          <span class="label -setting">設定する</span>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p class="p-account-note" v-if="nextGradeStore.classroom_list.length === 0">※変更が必要な場合は、先生へ連絡してください。</p>
              </div>
            </div>
          </section>
        </div>
      </main>
    </template>
  </app-layout>
</template>

<script setup lang="ts">
  import {ref, onMounted} from 'vue';
  import {useRouter} from "vue-router"
  import Logout from "@/pages/student/Logout.vue";
  import { useAccountStore } from '@/store/student/account_store';
  import { useGlobalNavigationStore } from '@/store/student/global_navigation_store';
  import { useNextGradeStore } from "@/store/student/next_grade";

  const router = useRouter()
  const accountGlobalMenu = ref(true)
  const accountStore = useAccountStore()
  const nextGradeStore = useNextGradeStore()
  const appLayoutRef = ref(null) // app-layoutのref to open next grade modal

  onMounted(() => {
    document.title = "アカウント"
    useGlobalNavigationStore().saveSelectedMenu("acAccount")
  })
  function goBack(){
    router.go(-1)
  }
</script>
